<div class="container">
  <div class="row">
    <div class="col-12">
      <!-- No appendTo="body": a body-appended dialog outlives this component
           when a navigation race destroys it, leaving a dead un-clickable
           overlay (user-reported 2026-08-14). Kept in the component subtree,
           it lives and dies with it. The *ngIf makes the dialog exist only
           while there are unacknowledged alerts — acknowledging collapses it
           in place, no navigation needed. -->
      <p-dialog
        *ngIf="(criticalNotifications$ | async)?.length"
        [style]="{ width: '100vw', maxWidth: '816px', maxHeight: '660px' }"
        [closeOnEscape]="false"
        [closable]="false"
        [modal]="true"
        [showHeader]="false"
        [visible]="true"
        transitionOptions="0ms"
      >
        <div class="dialog">
          <div class="dialog__content">
            <ng-container
              *ngIf="criticalNotifications$ | async as criticalNotifications"
            >
              <h2 class="mb-4">
                You received
                {{ (notificationCountByType$ | async).criticalInfoUpdated }}
                alerts
              </h2>
              <ul>
                <li *ngFor="let notification of criticalNotifications">
                  <div class="notifications__info">
                    <div class="notifications__info__patient">
                      <p>
                        {{
                          (
                            (notification.firstName || "") +
                            " " +
                            (notification.lastName || "")
                          ).trim() || notification.email
                        }}
                      </p>
                    </div>
                    <div class="notifications__info__items">
                      <ul>
                        <li *ngFor="let item of notification.items">
                          <p class="mb-3">
                            <span>from </span>
                            <span
                              class="crit-info"
                              [ngStyle]="{
                                background: item.payload?.changedFrom
                                  ? '#C7FFDC'
                                  : '#FEB0B0'
                              }"
                              >{{
                                item.payload?.propertyName ===
                                CRITICAL_INFO_TYPE.intubation
                                  ? item.payload?.changedFrom
                                    ? "YES, DO INTUBATION"
                                    : "DO NOT INTUBATE"
                                  : item.payload?.propertyName ===
                                    CRITICAL_INFO_TYPE.resuscitation
                                  ? item.payload?.changedFrom
                                    ? "YES, DO RESUSCITATION"
                                    : "DO NOT RESUSCITATE"
                                  : item.payload?.propertyName ===
                                    CRITICAL_INFO_TYPE.geneticTesting
                                  ? item.payload?.changedFrom
                                    ? "YES, I AGREE"
                                    : "NO, I DON`T AGREE"
                                  : item.payload?.changedFrom
                                  ? "YES, I AGREE"
                                  : "NO, I DON`T AGREE"
                              }}</span
                            >

                            <span> to </span>
                            <span
                              class="crit-info text--accent"
                              [ngStyle]="{
                                background: item.payload?.changedTo
                                  ? '#C7FFDC'
                                  : '#FEB0B0'
                              }"
                              >{{
                                item.payload?.propertyName ===
                                CRITICAL_INFO_TYPE.intubation
                                  ? item.payload?.changedTo
                                    ? "YES, DO INTUBATION"
                                    : "DO NOT INTUBATE"
                                  : item.payload?.propertyName ===
                                    CRITICAL_INFO_TYPE.resuscitation
                                  ? item.payload?.changedTo
                                    ? "YES, DO RESUSCITATION"
                                    : "DO NOT RESUSCITATE"
                                  : item.payload?.propertyName ===
                                    CRITICAL_INFO_TYPE.geneticTesting
                                  ? item.payload?.changedTo
                                    ? "YES, I AGREE"
                                    : "NO, I DON`T AGREE"
                                  : item.payload?.changedTo
                                  ? "YES, I AGREE"
                                  : "NO, I DON`T AGREE"
                              }}</span
                            >
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
              </ul>
              <div class="dialog__content__action">
                <div class="field-checkbox">
                  <p-checkbox
                    [(ngModel)]="checked"
                    [binary]="true"
                    inputId="binary"
                  ></p-checkbox>
                  <label class="checkbox-label" for="binary">
                    I acknowledge</label
                  >
                  <p
                    class="button-wrapper gap-20 d-flex justify-content-start mt-4"
                  >
                    <button
                      pButton
                      type="submit"
                      [disabled]="!checked"
                      label="CONFIRM"
                      (click)="confirm(criticalNotifications)"
                    ></button>
                  </p>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </p-dialog>
    </div>
  </div>
</div>
